import 'antd/lib/popover/style';
import 'antd/lib/input/style';
import 'antd/lib/tag/style';
import 'antd/lib/icon/style';

import '../ztreeSelect.less';